<template>
<AmazonSVG v-if="platform == 'amazon'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Amazon Fire TV'" />
<AppleSVG v-if="platform == 'apple'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'macOS'" />
<EpicGamesSVG v-if="platform == 'egs'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Epic Games Store'" />
<GoogleSVG v-if="platform == 'google'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Google Play Store'" />
<HumbleSVG v-if="platform == 'humble'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Humble'" />
<LinuxSVG v-if="platform == 'linux'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Linux'" />
<LunaSVG v-if="platform == 'luna'" :clasv-bind="$attrs" s="['icon', ...classes]" :alt="alt || 'Amazon Luna'" />
<MacAppStoreSVG v-if="platform == 'mas'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Mac App Store'" />
<NintendoSwitchSVG v-if="platform == 'nintendo-switch'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Nintendo Switch'" />
<PlaystationSVG v-if="platform == 'ps'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Playstation'" />
<ShopifySVG v-if="platform == 'shopify'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Add to Cart'" />
<SteamSVG v-if="platform == 'steam'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Steam'" />
<SteamAltSVG v-if="platform == 'steam-alt'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Steam'" />
<XboxSVG v-if="platform == 'xbox'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Xbox'" />
<WindowsSVG v-if="platform == 'windows'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Windows'" />
<WindowsAltSVG v-if="platform == 'windows-alt'" v-bind="$attrs" :class="['icon', ...classes]" :alt="alt || 'Windows'" />
</template>

<script lang="ts">
import AmazonSVG from 'public/images/icons/platforms/amazon.svg.vue'
import AppleSVG from 'public/images/icons/platforms/apple.svg.vue'
import EpicGamesSVG from 'public/images/icons/platforms/egs.svg.vue'
import GoogleSVG from 'public/images/icons/platforms/google.svg.vue'
import HumbleSVG from 'public/images/icons/platforms/humble.svg.vue'
import LinuxSVG from 'public/images/icons/platforms/linux.svg.vue'
import LunaSVG from 'public/images/icons/platforms/luna.svg.vue'
import MacAppStoreSVG from 'public/images/icons/platforms/mas.svg.vue'
import NintendoSwitchSVG from 'public/images/icons/platforms/nintendo-switch.svg.vue'
import PlaystationSVG from 'public/images/icons/platforms/ps.svg.vue'
import ShopifySVG from 'public/images/icons/platforms/shopify.svg.vue'
import SteamSVG from 'public/images/icons/platforms/steam.svg.vue'
import SteamAltSVG from 'public/images/icons/platforms/steam-alt.svg.vue'
import XboxSVG from 'public/images/icons/platforms/xbox.svg.vue'
import WindowsSVG from 'public/images/icons/platforms/windows-white.svg.vue'
import WindowsAltSVG from 'public/images/icons/platforms/windows-alt.svg.vue'

export default defineNuxtComponent({
    components: {
        AmazonSVG,
        AppleSVG,
        EpicGamesSVG,
        GoogleSVG,
        HumbleSVG,
        LinuxSVG,
        LunaSVG,
        MacAppStoreSVG,
        NintendoSwitchSVG,
        PlaystationSVG,
        ShopifySVG,
        SteamSVG,
        SteamAltSVG,
        XboxSVG,
        WindowsSVG,
        WindowsAltSVG
    },
    props: {
        platform: {
            type: String,
            required: true
        },
        iconColor: {
            type: String,
            default: 'currentColor'
        },
        classes: {
            type: Array,
            default: []
        },
        alt: {
            type: String,
            default: ''
        },
        focusable: {
            type: Boolean,
            required: false
        }
    }
})
</script>

<style scoped lang="scss">
    .icon {
        color: v-bind(iconColor);
        width: 100%;
        height: 100%;
    }
</style>
